import React from 'react';

import { Divider, Radio, RadioChangeEvent, Space } from 'antd';

interface SelectLanguageI {
   locale: string;
   lang: string;
   onChangeLocale: (value: string) => void;
   onChangeLang: (value: string) => void;
}

const SelectLanguage = ({ locale, lang, onChangeLocale, onChangeLang }: SelectLanguageI) => {
   const handleChangeLocale = (e: RadioChangeEvent) => onChangeLocale(e.target.value);

   const handleChangeLang = (e: RadioChangeEvent) => onChangeLang(e.target.value);

   return (
      <div>
         <Radio.Group onChange={handleChangeLocale} value={locale}>
            <Space direction='vertical'>
               <Radio value={'es'}>
                  <Space>
                     <span role='img' aria-label='mx'>
                        🇲🇽
                     </span>
                     {lang === 'es' ? 'México' : 'Mexico'}
                  </Space>
               </Radio>
               <Radio value={'en'}>
                  <Space>
                     <span role='img' aria-label='eu'>
                        🇺🇸
                     </span>
                     {lang === 'es' ? 'Estados Unidos' : 'United States'}
                  </Space>
               </Radio>
               <Radio value={'es-ES'}>
                  <Space>
                     <span role='img' aria-label='es-ES'>
                        🇪🇸
                     </span>
                     {lang === 'es' ? 'España' : 'Spain'}
                  </Space>
               </Radio>
               <Radio value={'co'}>
                  <Space>
                     <span role='img' aria-label='co'>
                        🇨🇴
                     </span>
                     {lang === 'es' ? 'Colombia' : 'Colombia'}
                  </Space>
               </Radio>
               <Radio value={'pa'}>
                  <Space>
                     <span role='img' aria-label='pa'>
                        🇵🇦
                     </span>
                     {lang === 'es' ? 'Panamá' : 'Panama'}
                  </Space>
               </Radio>
               <Radio value={'pr'}>
                  <Space>
                     <span role='img' aria-label='pr'>
                        🇵🇷
                     </span>
                     {lang === 'es' ? 'Puerto Rico' : 'Puerto Rico'}
                  </Space>
               </Radio>
               <Radio value={'ar'}>
                  <Space>
                     <span role='img' aria-label='ar'>
                        🇦🇷
                     </span>
                     {lang === 'es' ? 'Argentina' : 'Argentina'}
                  </Space>
               </Radio>
               <Radio value={'pe'}>
                  <Space>
                     <span role='img' aria-label='ar'>
                        🇵🇪
                     </span>
                     {lang === 'es' ? 'Perú' : 'Peru'}
                  </Space>
               </Radio>
               {/* <Radio value={'cl'}>
                  <Space>
                     <span role='img' aria-label='cl'>
                        🇨🇱
                     </span>
                     {lang === 'es' ? 'Chile' : 'Chile'}
                  </Space>
               </Radio> */}
            </Space>
         </Radio.Group>
         <Divider />
         <Radio.Group onChange={handleChangeLang} value={lang}>
            <Space direction='vertical'>
               <Radio value={'es'}>{lang === 'es' ? 'Español' : 'Spanish'}</Radio>
               <Radio value={'en'}>{lang === 'es' ? 'Ingles' : 'English'}</Radio>
               {/* <Radio value={'PT'}>Portugues</Radio> */}
            </Space>
         </Radio.Group>
      </div>
   );
};
export default SelectLanguage;
